import { render, staticRenderFns } from "./EquipamientoForm.vue?vue&type=template&id=2fd838fb"
import script from "./EquipamientoForm.vue?vue&type=script&lang=js"
export * from "./EquipamientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports